var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useCallback, useState } from 'react';
import gql from 'graphql-tag';
import styled from 'styled-components';
import { Button, CardHeader, CardSection, Flex, Heading, ModalDialog } from '@zillow/constellation';
import ContactAgentFormContent from './ContactAgentFormContent';
import AbadContent from './AbadContent';
import SuccessContent from './SuccessContent';
import { DisplayState } from '../constants';
import { getCopy, SEBASTIAN_CMA_FORM_VERSION } from '../utils/copyUtils';

var ModalDisplay = function ModalDisplay(_ref) {
  var modalDialogProps = _ref.modalDialogProps,
      header = _ref.header,
      body = _ref.body,
      footer = _ref.footer;
  return /*#__PURE__*/React.createElement(ModalDialog, _extends({
    "data-testid": "contact-agent-form-modal",
    wide: true
  }, modalDialogProps, {
    header: header && /*#__PURE__*/React.createElement(Heading, {
      level: 4
    }, header),
    body: body,
    footer: footer
  }));
};

var StyledCardHeader = styled(CardHeader).withConfig({
  displayName: "ContactAgentContainer__StyledCardHeader",
  componentId: "sc-ado8ay-0"
})(["text-align:", ";"], function (props) {
  return props.centerAlignedNote ? 'center' : 'left';
});

var CardDisplay = function CardDisplay(_ref2) {
  var header = _ref2.header,
      body = _ref2.body,
      footer = _ref2.footer,
      centerAlignedNote = _ref2.centerAlignedNote;
  return /*#__PURE__*/React.createElement(React.Fragment, null, header && /*#__PURE__*/React.createElement(StyledCardHeader, {
    centerAlignedNote: centerAlignedNote
  }, header), /*#__PURE__*/React.createElement(CardSection, null, body), footer && /*#__PURE__*/React.createElement(CardSection, null, footer));
};

var INITIAL_DISPLAY_STATE = DisplayState.FORM;

var ContactAgentContainer = function ContactAgentContainer(_ref3) {
  var property = _ref3.property,
      viewer = _ref3.viewer,
      page = _ref3.page,
      location = _ref3.location,
      _ref3$treatment = _ref3.treatment,
      treatment = _ref3$treatment === void 0 ? 'pl-lead-form' : _ref3$treatment,
      onSubmit = _ref3.onSubmit,
      onFetchAbadHtml = _ref3.onFetchAbadHtml,
      showCheckBox = _ref3.showCheckBox,
      centerAlignedNote = _ref3.centerAlignedNote,
      modalDialogProps = _ref3.modalDialogProps,
      shouldSuggestCloseOnSuccess = _ref3.shouldSuggestCloseOnSuccess,
      onClose = _ref3.onClose,
      abadClient = _ref3.abadClient,
      zatlasEndpoint = _ref3.zatlasEndpoint,
      contactFormVersion = _ref3.contactFormVersion,
      trackingParam = _ref3.trackingParam;

  var _useState = useState(INITIAL_DISPLAY_STATE),
      _useState2 = _slicedToArray(_useState, 2),
      displayState = _useState2[0],
      setDisplayState = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      abadHtml = _useState4[0],
      setAbadHtml = _useState4[1];

  var isModal = !!modalDialogProps;
  var formVersion = trackingParam !== null && trackingParam !== void 0 && trackingParam.toLowerCase().includes('_sebcmatest') ? SEBASTIAN_CMA_FORM_VERSION : contactFormVersion;
  var handleClose = useCallback(function () {
    // Reset for next time modal is opened
    setDisplayState(INITIAL_DISPLAY_STATE);

    if (onClose) {
      onClose();
    }
  }, [setDisplayState, onClose]); // Retain ModalDisplay constructor between renders

  var StableModalDisplay = useCallback(function (props) {
    if (!modalDialogProps) {
      return null;
    }

    var modalDisplayProps = Object.assign({}, props, {
      modalDialogProps: Object.assign({}, modalDialogProps, {
        onClose: handleClose
      })
    });
    return /*#__PURE__*/React.createElement(ModalDisplay, modalDisplayProps);
  }, [modalDialogProps, handleClose]);
  var DisplayComponent = isModal ? StableModalDisplay : CardDisplay; // Default to 'true' for modals

  var shouldShowSuccessCloseButton = shouldSuggestCloseOnSuccess === true || typeof shouldSuggestCloseOnSuccess === 'undefined' && isModal;

  var handleSubmit = function handleSubmit(params) {
    return new Promise(function ($return, $error) {
      return $return(onSubmit(params));
    });
  };

  var handleSubmitSuccess = function handleSubmitSuccess() {
    return new Promise(function ($return, $error) {
      var response;

      var $Try_3_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      var $Try_3_Catch = function (e) {
        try {
          setDisplayState(DisplayState.SUCCESS);
          return $Try_3_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(onFetchAbadHtml({
          viewer: viewer,
          abadClient: abadClient
        })).then(function ($await_4) {
          try {
            response = $await_4;

            if (response.text) {
              setAbadHtml(response.text);
              setDisplayState(DisplayState.ABAD_CONTENT);
            } else {
              // User has seen it or unexpectedly, no text was returned on response
              setDisplayState(DisplayState.SUCCESS);
            }

            return $Try_3_Post();
          } catch ($boundEx) {
            return $Try_3_Catch($boundEx);
          }
        }, $Try_3_Catch);
      } catch (e) {
        $Try_3_Catch(e)
      }
    });
  };

  switch (displayState) {
    case DisplayState.FORM:
      return /*#__PURE__*/React.createElement(DisplayComponent, {
        header: getCopy(formVersion, 'formHeader'),
        body: /*#__PURE__*/React.createElement(ContactAgentFormContent, {
          centerAlignedNote: centerAlignedNote,
          location: location,
          onSubmit: handleSubmit,
          onSubmitSuccess: handleSubmitSuccess,
          page: page,
          treatment: treatment,
          property: property,
          showCheckBox: showCheckBox,
          viewer: viewer,
          zatlasEndpoint: zatlasEndpoint,
          contactFormVersion: formVersion,
          trackingParam: trackingParam
        }),
        footer: null,
        centerAlignedNote: centerAlignedNote
      });

    case DisplayState.ABAD_CONTENT:
      return /*#__PURE__*/React.createElement(DisplayComponent, {
        header: /*#__PURE__*/React.createElement(React.Fragment, null, "What you need to know about ", /*#__PURE__*/React.createElement("strong", null, "Zillow"), " and its affiliated businesses"),
        body: /*#__PURE__*/React.createElement(AbadContent, {
          isModal: isModal,
          abadHtml: abadHtml
        }),
        footer: /*#__PURE__*/React.createElement(Flex, {
          display: "flex",
          justifyContent: "flex-end"
        }, /*#__PURE__*/React.createElement(Button, {
          buttonType: "primary",
          "data-testid": "confirm-abad-button",
          onClick: function onClick() {
            return setDisplayState(DisplayState.SUCCESS);
          },
          type: "button"
        }, "Ok, got it!")),
        centerAlignedNote: centerAlignedNote
      });

    case DisplayState.SUCCESS:
      return /*#__PURE__*/React.createElement(DisplayComponent, {
        header: "Message sent",
        body: /*#__PURE__*/React.createElement(SuccessContent, {
          shouldShowPrimaryCloseButton: shouldShowSuccessCloseButton,
          onClose: handleClose,
          contactFormVersion: formVersion
        }),
        footer: null,
        centerAlignedNote: centerAlignedNote
      });

    default:
      throw new Error("Display state not supported: " + displayState);
  }
};

ContactAgentContainer.fragments = {
  property: gql(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        fragment ContactAgentForm_property on Property {\n            streetAddress\n            state\n            city\n            zipcode\n            zpid\n            homeStatus\n            homeType\n            zestimate\n            homeType\n            isInstantOfferEnabled\n            zillowOfferMarket {\n                name\n                code\n            }\n        }\n    "]))),
  viewer: gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        fragment ContactAgentForm_viewer on Viewer {\n            name\n            email\n            zuid\n        }\n    "]))),
  abTests: gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        fragment ContactAgentForm_abTests on ABTests {\n            SHOW_PL_LEAD_FORM: abTest(trial: \"SHOW_PL_LEAD_FORM\")\n        }\n    "])))
};
export default ContactAgentContainer;
//# sourceMappingURL=ContactAgentContainer.js.map